// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"4ef9a9f0","698":"cb369d12"}[chunkId] + ".chunk.js";
};